import {Component, EventEmitter, Inject, OnDestroy, OnInit, Optional, Output} from '@angular/core';
import {UntypedFormBuilder, UntypedFormGroup, Validators} from '@angular/forms';
import {Subscription} from 'rxjs';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {Problem, ProblemListRepositoryService} from '@xmedical/core';

@Component({
    selector: 'app-problem-item-add-card',
    templateUrl: './problem-item-add-card.component.html',
    styleUrls: ['./problem-item-add-card.component.scss'],
    standalone: false
})
export class ProblemItemAddCardComponent implements OnInit, OnDestroy {

  constructor(
    private dialogRef: MatDialogRef<ProblemItemAddCardComponent>,
    private formBuilder: UntypedFormBuilder,
    private problemListRepository: ProblemListRepositoryService,
    @Optional() @Inject(MAT_DIALOG_DATA) public data: { searchTerm?: string }) { }
  private repositorySubscription: Subscription;
  validate = false;
  form: UntypedFormGroup;
  @Output() problemItemSaved: EventEmitter<Problem> = new EventEmitter();


  ngOnInit(): void {
    this.form = this.formBuilder.group({
      problem: [this.data?.searchTerm || '', Validators.required],
    });
  }

  ngOnDestroy(): void {
    if (this.repositorySubscription) { this.repositorySubscription.unsubscribe(); }
  }


  save() {
    if (this.form.valid) {
      const problem = this.formToProblem();
      this.repositorySubscription = this.problemListRepository.createProblemItem(problem).subscribe(id => {
        problem.id = id;  // Add the returned ID to the form data
        this.dialogRef.close(problem);
      });
    }
    this.validate = true;
  }

  close() {
    this.dialogRef.close();
  }

  private formToProblem(): Problem {
    return this.form.value as Problem;
  }

}
